import {
  useForwardAccumulatorSelector,
  useForwardAccumulatorTileId,
} from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { TraderInfos } from '@/components/TraderInfos.tsx';
import {
  getForwardAccumulatorContribution,
  getForwardAccumulatorTraderId,
} from '@/store/forwardAccumulator/selectors.ts';

export const ForwardAccumulatorTraderInfos = () => {
  const tileId = useForwardAccumulatorTileId();

  const traderId = useForwardAccumulatorSelector(getForwardAccumulatorTraderId);

  const contribution = useForwardAccumulatorSelector(getForwardAccumulatorContribution);

  return <TraderInfos contribution={contribution} tileId={tileId} traderId={traderId} />;
};
